import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import React from 'react';
import { useState } from 'react';
import { ValueRender } from './AttributeCell';

export const DropDownCell = (props: any) => {
    const localizedData = props.data;
    const [data, setData] = useState<any>(localizedData?.slice());

    const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data: any[] = localizedData!.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        setData(filterData(event.filter));
    };
    const handleChange = (e: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value,
            });
        }
    };

    const { dataItem } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];
    const clear = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        handleChange({
            target: {
                value: null,
            },
        } as any);
    };

    return (
        <DropDownList
            {...props}
            data={data}
            onChange={handleChange}
            value={localizedData?.find((c: any) => c?.id === dataValue?.id)}
            disabled={props.disabled}
            onFilterChange={filterChange}
            filterable={props?.filterable ?? true}
            valueRender={(element, value) => {
                return (
                    <ValueRender
                        element={element}
                        value={value}
                        textField={props.textField}
                        hasDeleteOption={props.hasDeleteOption}
                        clear={(e: any) => clear(e)}
                    />
                );
            }}
        />
    );
};
